import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { PaymentIndexView } from '../../../../types/payments';
import { PaymentApis } from '../../../../apis/payments';
import { CardSummary } from '../../../../../mainv2/types/card';
import { UserApis } from '../../../../../mainv2/api';

export class PaymentListPaneState {
    @observable cardSummary: RemoteResourceV3<CardSummary> = RemoteResourceV3.loading();
    @observable payments: RemoteResourceV3<PaymentIndexView[]> = RemoteResourceV3.loading();

    @action.bound
    async init() {
        this.reloadPayments();
        this.reloadCardSummary();
    }

    @action.bound
    async reloadPayments() {
        await updateRemoteResourceV3(this.payments, (v) => (this.payments = v), () => PaymentApis.findAll());
    }

    @action.bound
    async reloadCardSummary() {
        await updateRemoteResourceV3(this.cardSummary, (v) => (this.cardSummary = v), () => UserApis.getCurrentCard());
    }
}
